import React, { useState } from "react";
import { useStripe, CardElement, useElements } from "@stripe/react-stripe-js";
import { Primary } from "../../stories/Button.stories";
import UserService from "../../services/user.service";
import ToastBlockContainer from "../../common/ToastBlockContainer";

const NewCardForm = (props) => {
  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [successToast, setSuccessToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  var isCardComplete = false;
  var UserDetails = JSON.parse(localStorage.getItem("UserDetails"));
  // var cardVal = JSON.parse(localStorage.getItem("hi"));

  const initialValues = {
    name: UserDetails.firstname + " " + UserDetails.lastname,
    country: "GB",
    isCardValid: false,
  };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [isDisabled, setIsDisabled] = useState(false);

  const handleCardChange = (e) => {
    if (e.complete) {
      isCardComplete = true;
      setFormValues({ ...formValues, isCardValid: isCardComplete });
    } else {
      setLoading(false);
      // setIsDisabled(false);
      setFormValues({ ...formValues, isCardValid: false });
    }

    if (isCardComplete || formValues.isCardValid) {
      if (
        formValues.name &&
        formValues.addressLine1 &&
        formValues.addressLine2 &&
        formValues.city &&
        formValues.state
      ) {
        // setIsDisabled(false);
      }
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });

    if (isCardComplete || formValues.isCardValid) {
      if (
        formValues.name &&
        formValues.addressLine1 &&
        formValues.addressLine2 &&
        formValues.city &&
        formValues.state
      ) {
        // setIsDisabled(false);
      }
    }
  };

  const handleSubmit = (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    setFormErrors(validate(formValues));

    if (Object.keys(formErrors).length > 0) {
    }
    // handle confirm submit
    if (Object.keys(formErrors).length === 0) {
      // setIsDisabled(false);
      setLoading(true);
      // create payment method
      if (
        formValues.country === "" ||
        formValues.city === "" ||
        formValues.addressLine1 === "" ||
        formValues.addressLine2 === "" ||
        formValues.state === "" ||
        formValues.name === ""
      ) {
        setLoading(true);
        setShowToast(true);
        setSuccessToast(false);
        setToastMessage("Please fill all the blank places");
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      } else {
        stripe
          .createPaymentMethod({
            type: "card",
            card: elements.getElement(CardElement),
            billing_details: {
              name: formValues.name,
              address: {
                city: formValues.city,
                country: formValues.country,
                line1: formValues.addressLine1,
                line2: formValues.addressLine2,
                state: formValues.state,
              },
            },
          })
          .then(function (result) {
            // attach payment method
            let attachData = { customer: props.customerId };
            let pushArr = [];
            pushArr.push(props.cardsaved);

            if (result.paymentMethod != undefined) {
              if (pushArr[0].includes(result.paymentMethod.card.last4)) {
                setLoading(false);
                setShowToast(true);
                setSuccessToast(false);
                setToastMessage("Please add different card no");
              } else {
                UserService.attachPaymentMethod(
                  attachData,
                  result.paymentMethod.id
                ).then((response) => {
                  setLoading(false);
                  setShowToast(true);
                  setSuccessToast(true);
                  setToastMessage("Your card successfully added");
                  props.setNewCard(response);
                  props.cardsaved.push(result.paymentMethod.card.last4);
                  // setTimeout(() => {
                  //   window.location.reload();
                  // }, 2000);
                });
              }
            } else {
              setLoading(true);
              setShowToast(true);
              setSuccessToast(false);
              setToastMessage("Please fill all the blank places");
              setTimeout(() => {
                setLoading(false);
              }, 1000);
            }
          });
      }
    }
  };

  const validate = (values) => {
    const errors = {};
    if (
      !values.name &&
      !values.addressLine1 &&
      !values.addressLine2 &&
      !values.city &&
      !values.state &&
      !values.country
    ) {
      errors.msg = "Please enter family name";
      errors.name = "Yes";
      errors.addressLine1 = "Yes";
      errors.addressLine2 = "Yes";
      errors.city = "Yes";
      errors.state = "Yes";
      errors.country = "Yes";
    } else {
    }
    return errors;
  };

  return (
    <>
      <ToastBlockContainer
        successToast={successToast}
        showToast={showToast}
        setShowToast={setShowToast}
        toastMessage={toastMessage}
      />
      <form className="payment-form" onSubmit={handleSubmit}>
        <label
          className={
            formErrors.name ? "invalid-text form-label mb-0" : "form-label mb-0"
          }
        >
          Name on the card
        </label>
        <input
          type="test"
          errorClass={formErrors.name ? "invalid-input" : ""}
          placeholder="John Mike"
          size="small"
          name="name"
          value={formValues.name}
          onChange={handleChange}
          className="form-control mb-3"
        />
        <label className="form-label ">Card Number</label>
        <CardElement
          onChange={handleCardChange}
          className="form-control card-element mb-3"
          options={{ hidePostalCode: true }} // Hide ZIP field
        />
        <div className="text-center">
          <Primary
            children="Add Card"
            variant="primary"
            size="mediumbtn"
            type="submit"
            className="btn btn-primary"
            disabled={isDisabled ? "disabled" : ""}
            isLoading={loading ? "true" : "false"}
            isDisabled={loading ? "true" : "false"}
          />
          {message && <div id="payment-message">{message}</div>}
        </div>
      </form>
    </>
  );
};

export default NewCardForm;
